import DOMPurify from "dompurify";

const SafeHtmlComponent: React.FC<{ html: string }> = ({ html }) => {
  const sanitizedHtml = DOMPurify.sanitize(html); // Sanitize input

  return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

export default SafeHtmlComponent;
